/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_calendar__arrival__title = /** @type {(inputs: {}) => string} */ () => {
	return `Wählen Sie ein Ankunftsdatum aus.`
};

const en_calendar__arrival__title = /** @type {(inputs: {}) => string} */ () => {
	return `Select an arrival date`
};

const es_calendar__arrival__title = /** @type {(inputs: {}) => string} */ () => {
	return `Selecciona una fecha de llegada`
};

const fr_calendar__arrival__title = /** @type {(inputs: {}) => string} */ () => {
	return `Sélectionnez une date d'arrivée`
};

const it_calendar__arrival__title = /** @type {(inputs: {}) => string} */ () => {
	return `Seleziona una data di arrivo`
};

const nl_calendar__arrival__title = /** @type {(inputs: {}) => string} */ () => {
	return `Selecteer een aankomstdatum`
};

const pt_calendar__arrival__title = /** @type {(inputs: {}) => string} */ () => {
	return `Selecione uma data de chegada`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const calendar__arrival__title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.calendar__arrival__title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("calendar__arrival__title", locale)
	if (locale === "de") return de_calendar__arrival__title(inputs)
	if (locale === "en") return en_calendar__arrival__title(inputs)
	if (locale === "es") return es_calendar__arrival__title(inputs)
	if (locale === "fr") return fr_calendar__arrival__title(inputs)
	if (locale === "it") return it_calendar__arrival__title(inputs)
	if (locale === "nl") return nl_calendar__arrival__title(inputs)
	return pt_calendar__arrival__title(inputs)
};